<script setup lang="ts">
import { Footer, HostNavbar, ResourcesSection } from "@/components"
import { AuthProvider } from "@/providers"
</script>

<template>
  <AuthProvider>
    <div>
      <div class="host-bg fixed inset-0 -z-10 bg-center bg-cover bg-no-repeat" />
      <header>
        <slot name="navbar">
          <HostNavbar />
        </slot>
      </header>
      <main class="relative">
        <div class="container my-16">
          <slot name="default" />
        </div>
        <ResourcesSection class="mt-24" />
        <slot name="footer">
          <Footer />
        </slot>
      </main>
    </div>
  </AuthProvider>
</template>

<style scoped>
.host-bg {
  background-image: url("@/assets/host_bg.png");
}
</style>
